import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { validateGlobalApi } from "./validations.js";
var IdentifierUseMap = new Map([["useQuery", "query"], ["usePathParams", "pathParams"], ["useApp", "app"], ["useAuth", "auth"], ["useHistory", "history"], ["useLocation", "location"]]);
export function parseIdentifierUse(decl, callee, args, state) {
  var _iterator = _createForOfIteratorHelper(IdentifierUseMap),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        useName = _step$value[0],
        kind = _step$value[1];
      if (validateGlobalApi(callee, useName)) {
        var declId = decl.get("id");
        if (!declId.isIdentifier()) {
          state.errors.push({
            message: "".concat(useName, "() must be assigned to an identifier, received ").concat(declId.type),
            node: declId.node,
            severity: "error"
          });
          break;
        }
        if (args.length > 0) {
          state.errors.push({
            message: "".concat(useName, "() does not accept any arguments, received ").concat(args.length),
            node: args[0].node,
            severity: "warning"
          });
        }
        return [declId.node, {
          id: declId.node,
          kind: kind
        }];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}
//# sourceMappingURL=parseIdentifierUse.js.map